<template>
  <div class="facet my-[2vh] mx-0">
    <box-generic w-stretch :header-class="computedHeaderClass">
      <template #header><slot :name="type + 'Label'" /></template>
      <template #default>
        <div class="facet-link-wrapper">
          <router-link
            v-for="facetItem in items"
            :key="facetItem.key"
            :to="facetItem.route"
            class="facet-link"
            :class="computedSchoolLevelBg"
          >
            <slot :name="type" :item="facetItem.item" />
          </router-link>
        </div>
      </template>
    </box-generic>
  </div>
</template>

<script>
import BoxGeneric from "../BoxGeneric.vue";

import { mapGetters } from "vuex";

export default {
  name: "MediaArchiveFacet",
  components: {
    BoxGeneric,
  },
  computed: {
    ...mapGetters(["routedSong"]),
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),

    /**
     * Computes the header class for the BoxGeneric component.
     * Always includes the base "title-block" class.
     * If a school level is active, adds a modifier class based on its slug,
     * e.g., "title-block-onderbouw", "title-block-middenbouw", etc.
     */
    computedHeaderClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      return slug ? `title-block title-block-${slug}` : "title-block";
    },
    computedSchoolLevelBg() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      if (!slug) return "";

      const bgMap = {
        onderbouw: "bg-yellow-200 hover:bg-yellow",
        "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen",
      };

      return bgMap[slug] || "";
    },
  },
  props: {
    type: {
      type: String,
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
